export const useLibraryStrategyPage = (): UseLibraryStrategy => {
  const type = 'page';
  const route = useRoute();
  const slugs = computed(() => [...route.params.slugs]);
  const hasPrevious = computed(() => slugs.value.length > 0);
  const setRoute = (path: string) => {
    throw new Error('For useLibraryStrategyPage use vue router');
  };
  const goBack = () => {
    throw new Error('For useLibraryStrategyPage use vue router');
  };
  const path = computed<string>(() => {
    return route.path;
  });
  return {
    type,
    slugs,
    setRoute,
    goBack,
    path,
    hasPrevious,
  };
};
